import React from 'react';
import { Search } from 'lucide-react';

export const SORT_OPTIONS = [
  { value: 'newest', label: 'Newest first' },
  { value: 'oldest', label: 'Oldest first' },
  { value: 'highest_rated', label: 'Highest rated' },
  { value: 'lowest_rated', label: 'Lowest rated' },
];

const RATING_FILTERS = [
  { value: '', label: 'All' },
  { value: '5', label: '5 ★' },
  { value: '4', label: '4 ★' },
  { value: '3', label: '3 ★' },
  { value: '2', label: '2 ★' },
  { value: '1', label: '1 ★' },
];

const ReviewFilters = ({
  services = [],
  searchQuery = '',
  serviceUuid = '',
  rating = '',
  sort = 'newest',
  disabled = false,
  onSearchChange,
  onServiceChange,
  onRatingChange,
  onSortChange,
}) => (
  <div className="customer-reviews__filters">
    <label className="customer-reviews__search">
      <Search size={16} aria-hidden="true" />
      <input
        type="search"
        value={searchQuery}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder="Search reviews, services, customer ID..."
        aria-label="Search reviews"
        disabled={disabled}
      />
    </label>

    <select
      className="customer-reviews__filter"
      value={serviceUuid}
      onChange={(e) => onServiceChange(e.target.value)}
      aria-label="Filter by service"
      disabled={disabled}
    >
      <option value="">All services</option>
      {services.map((s) => (
        <option key={s.value} value={s.value}>{s.label}</option>
      ))}
    </select>

    <div className="customer-reviews__rating-filters" aria-label="Filter by rating">
      {RATING_FILTERS.map((option) => (
        <button
          key={option.value || 'all'}
          type="button"
          className={rating === option.value ? 'customer-reviews__rating-filter is-active' : 'customer-reviews__rating-filter'}
          disabled={disabled}
          onClick={() => onRatingChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>

    <select
      className="customer-reviews__filter"
      value={sort}
      onChange={(e) => onSortChange(e.target.value)}
      aria-label="Sort reviews"
      disabled={disabled}
    >
      {SORT_OPTIONS.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  </div>
);

export default ReviewFilters;
